import { z } from 'zod'
import { Model } from './architecture'

export const TitleValidation = z.object({
  value: z.string({ required_error: '[Title] value is required' }),
})

export class Title extends Model {
  static create({ value }: z.infer<typeof TitleValidation>) {
    TitleValidation.parse({ value })
    return new Title(value, false)
  }

  static empty() {
    return new Title('', true)
  }

  constructor(
    private readonly _value: string,
    private readonly _empty: boolean
  ) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  isEmpty() {
    return this._empty
  }

  toJSON() {
    return { value: this.value }
  }
}
